export default "__VITE_ASSET__8949b915__"